import { ApplicationConfigClient } from '../shared/ApplicationConfigClient';
import { PARAM } from '../../../constants/reading/ApiConstants';
import { READING_APPLICATION_NAME } from '../../../constants/shared/CommonConstants';
import { convertObjToGqlQuery } from '../../../utils/shared/commonUtils';

const { APPLICATION_NAME, APPLICATION_CONFIG } = PARAM;

class ReadingApplicationConfigClient extends ApplicationConfigClient {
    appConfigKey = APPLICATION_CONFIG;

    appNameConfigParam = `${APPLICATION_NAME}: "${READING_APPLICATION_NAME}"`;

    getApplicationConfigParams = () => [this.appNameConfigParam];

    getApplicationConfigMutationParams = ({ updatedPdfAvailability, pdfAvailabilityBK }) => [
        this.appNameConfigParam,
        `${this.appConfigKey}: {
           pdfAvailability: ${convertObjToGqlQuery(updatedPdfAvailability)},
           pdfAvailability_bk: "${pdfAvailabilityBK || ''}"
       }`,
    ];
}

export default new ReadingApplicationConfigClient();
